(function () {
    'use strict';
    angular.module('app').controller('expediteApprove', expediteApprove);
    expediteApprove.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', 'SelectionCommand_WorkflowService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'uiGridConstants', 'editEmailsService', 'approvalAuthService'];
    function expediteApprove($location, scope, $rootScope, gridDataService, SelectionCommand_WorkflowService, $timeout, $mdDialog, records, command, commandService, loginService, uiGridConstants, editEmailsService, approvalAuthService) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        scope.ACN_EXPEDITOR_APPROVE = 128;
        scope.ACN_EXPEDITOR_REJECT = 131;
        scope.ACN_REJECT_TO = 130;
        scope.FINAL_APPROVE_STEP_ID = "FINAL_APPROVE_STEP_ID";
        scope.xyz = { bReadyForOK: false, comment: "", bCreateVersion: false };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // PL-OBS?
        //scope.$on('expediteApproveButtonClicked', function (event, arg) {
        //    scope.onExpediteApproveButtonClicked(arg.slx);
        //});
        //scope.$on('expediteRejectButtonClicked', function (event, arg) {
        //    scope.onExpediteRejectButtonClicked(arg.slx);
        //});
        //scope.$on('rejectToButtonClicked', function (event, arg) {
        //    scope.onRejectToButtonClicked(arg.slx);
        //});

        // =====================================
        // On Load. Assign To.
        // =====================================
        // Set the combo to 'building list'.
        scope.qualifiedUsersArrayLoading = function () {
            // If already on the 'building list', just leave it.
            if (scope.xyz.selectedUserItem != scope.qualifiedUsersBuildingList) {
                // Clear the array.
                scope.qualifiedUsersArray = [];
                // Add 'building list' to the array.
                scope.qualifiedUsersArray.push(scope.qualifiedUsersBuildingList);
                // Select 'building list' in the combo.
                scope.xyz.selectedUserItem = scope.qualifiedUsersBuildingList;
                // We are waiting for the items.
                scope.xyz.gettingUserList = true;
            }
        };
        // Load items into the combo. May be null.
        scope.qualifiedUsersArrayLoad = function (users) {
            // Clear the array.
            scope.qualifiedUsersArray = [];
            // Add 'pick one'.
            scope.qualifiedUsersArray.push(scope.qualifiedUsersPickOne);
            // Select 'pick one'.
            scope.xyz.selectedUserItem = scope.qualifiedUsersPickOne;
            // Add ''.
            scope.qualifiedUsersArray.push(scope.qualifiedUsersBlank);
            // If there are items, ...
            if (users != null) {
                // Walk the items, ...
                angular.forEach(users, function (name, id) {
                    // Add the item to the array.
                    scope.qualifiedUsersArray.push({ id: id, name: name })
                });
            }
            // We are done getting the items.
            scope.xyz.gettingUserList = false;
        }
        // Create a 'building list' item.
        scope.qualifiedUsersBuildingList = { id: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
        // Create a 'pick one' item.
        scope.qualifiedUsersPickOne = { id: 'pick_one', name: "- " + loginService.resourceStrings["COMBO_BOX_PICK_ONE"] + " -" };
        // Create a '' item.
        scope.qualifiedUsersBlank = { id: '', name: '' };
        // Initailize to the 'building list' state.
        scope.qualifiedUsersArrayLoading();

        // =====================================
        // On Load. Steps.
        // =====================================
        // Set the combo to 'building list'.
        scope.qualifiedStepsArrayLoading = function () {
            // If already on the 'building list', just leave it.
            if (scope.xyz.selectedStepItem != scope.qualifiedStepsBuildingList) {
                // Clear the array.
                scope.qualifiedStepsArray = [];
                // Add 'building list' to the array.
                scope.qualifiedStepsArray.push(scope.qualifiedStepsBuildingList);
                // Select 'building list' in the combo.
                scope.xyz.selectedWorkflowStepItem = scope.qualifiedStepsBuildingList;
                // We are waiting for the items.
                scope.xyz.gettingStepList = true;
            }
        };
        // Load items into the combo. May be null.
        scope.qualifiedStepsArrayLoad = function (steps) {
            // Clear the array.
            scope.qualifiedStepsArray = [];
            // Add 'pick one'.
            scope.qualifiedStepsArray.push(scope.qualifiedStepsPickOne);
            // Select 'pick one'.
            scope.xyz.selectedWorkflowStepItem = scope.qualifiedStepsPickOne;
            // Add ''.
            scope.qualifiedStepsArray.push(scope.qualifiedStepsBlank);
            // If there are items, ...
            if (steps != null) {
                // Walk the items, ...
                angular.forEach(steps, function (name, id) {
                    // Add the item to the array.
                    scope.qualifiedStepsArray.push({ id: id, name: name })
                });
            }
            // We are done getting the items.
            scope.xyz.gettingStepList = false;
        }
        // Create a 'building list' item.
        scope.qualifiedStepsBuildingList = { id: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
        // Create a 'pick one' item.
        scope.qualifiedStepsPickOne = { id: 'pick_one', name: "- " + loginService.resourceStrings["COMBO_BOX_PICK_ONE"] + " -" };
        // Create a '' item.
        scope.qualifiedStepsBlank = { id: '', name: '' };
        // Initailize to the 'building list' state.
        scope.qualifiedStepsArrayLoading();

        // =====================================
        //
        // =====================================  

        //
        // On step change.
        //
        scope.selectedWorkflowStepChanged = function () {
            // If nothing selected, then return.
            if (scope.xyz.selectedWorkflowStepItem == null)
                return;
            // If user selected 'pick one', then return.
            if (scope.xyz.selectedWorkflowStepItem == scope.qualifiedStepsPickOne)
                return;

            // The main list.
            var items = [];

            //get the selected items
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                //var id = "";
                //var name = "";
                //if (scope.xyz.selectedWorkflowStepItem != null) {
                //    id = scope.xyz.selectedWorkflowStepItem.id;
                //    name = scope.xyz.selectedWorkflowStepItem.name;
                //}

                var nameForGrid = scope.xyz.selectedWorkflowStepItem.name;
                // EDGE-EMPTY
                if (scope.xyz.selectedWorkflowStepItem.name.length < 1) {
                    var browserInfo = navigator.userAgent;
                    var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                    if (bIsEdge) {
                        //name = '\u00A0';
                        nameForGrid = '\u00A0';
                    }
                }

                gridItem.workflowStepId = scope.xyz.selectedWorkflowStepItem.id;
                gridItem.workflowStep = nameForGrid; // name;
                gridItem.selectionItem.commandParams.eStepId = scope.xyz.selectedWorkflowStepItem.id; // *****

                // When changing step, also blank out user.
                // EDGE-EMPTY
                var assignToNameForGrid = "";
                var browserInfo = navigator.userAgent;
                var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                if (bIsEdge)
                    assignToNameForGrid = '\u00A0';
                //
                gridItem.assignToId = "";
                gridItem.assignTo = assignToNameForGrid;
                gridItem.selectionItem.commandParams.eAssignToUserId = ""; // *****

                //scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.EDIT);

                // Add to the main list.
                items.push(gridItem.selectionItem);
            });

            // Build the SL with mode and order.
            var slx = { mode: 0, order: 0, list: items };

            // Update valid assignees.
            scope.updateAssignToList(slx, items);

            // Do Enables.
            scope.doEnables();
        };

        //
        // On comment change.
        //
        scope.onCommentChanged = function () {

            var commentForGrid = scope.xyz.comment;
            // EDGE-EMPTY
            if (scope.xyz.comment.length < 1) {
                var browserInfo = navigator.userAgent;
                var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                if (bIsEdge) {
                    // scope.xyz.comment = '\u00A0';
                    commentForGrid = '\u00A0';
                }
            }

            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                gridItem.comment = commentForGrid; // scope.xyz.comment;
                gridItem.selectionItem.commandParams.eWorkflowComment = scope.xyz.comment; // *****
            });

            // Do Enables.
            scope.doEnables();
        };

        //
        // On user change.
        //
        scope.selectedUserChanged = function () {
            // If nothing selected, then return.
            if (scope.xyz.selectedUserItem == null)
                return;
            // If user selected 'pick one', then return.
            if (scope.xyz.selectedUserItem == scope.qualifiedUsersPickOne)
                return;

            var nameForGrid = scope.xyz.selectedUserItem.name;
            // EDGE-EMPTY
            if (scope.xyz.selectedUserItem.name.length < 1) {
                var browserInfo = navigator.userAgent;
                var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                if (bIsEdge) {
                    // scope.xyz.selectedUserItem.name = '\u00A0';
                    nameForGrid = '\u00A0';
                }
            }

            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                gridItem.assignToId = scope.xyz.selectedUserItem.id;
                gridItem.assignTo = nameForGrid; // scope.xyz.selectedUserItem.name;
                gridItem.selectionItem.commandParams.eAssignToUserId = scope.xyz.selectedUserItem.id; // *****
            });

            // Do Enables.
            scope.doEnables();
        };

        //
        // On check/uncheck of the Create Version checkbox.
        //
        scope.createVersionCheckChanged = function () {

            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                if (gridItem.bCanCreateVersion == 'T') {
                    gridItem.bCreateVersion = scope.xyz.bCreateVersion ? "T" : "F";
                    gridItem.selectionItem.commandParams.ebMakeRevision = scope.xyz.bCreateVersion; // *****
                }
            });

            // Do Enables.
            scope.doEnables();
        };

        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        //
        // Enables.
        //
        scope.doEnables = function () {
            // Does every row have an landing step?
            var bAllHaveTarget = true;
            // Do all steps that require a comment, have one?
            var bAllHaveRequiredComment = true;

            var bOneReq = false;
            var bOneCan = false;

            // ***** For label updates, only consider selected.
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                if (gridItem.bCommentRequired == 'T') {
                    bOneReq = true;
                }
                if (scope.mode == scope.ACN_EXPEDITOR_APPROVE
                    && gridItem.workflowStepId == scope.FINAL_APPROVE_STEP_ID) {
                    if (gridItem.bCanCreateVersion == 'T') {
                        bOneCan = true;
                    }
                }
            });
                
            // ***** For enable logic, consider all rows.
            angular.forEach(scope.gridOptions.data, function (gridItem) {
                // See if this row has a landing step.
                if (gridItem.workflowStep.length < 1)
                    bAllHaveTarget = false;
                // See if this row requires and comment and does not have one.
                if (gridItem.bCommentRequired == 'T' && gridItem.comment.length < 1)
                    bAllHaveRequiredComment = false;
            });

            // Update the comment label.
            if (bOneReq)
                scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT_REQUIRED"]; // "Enter Comment (required)";
            else
                scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT_OPTIONAL"]; // "Enter Comment (optional)";

            // Update the create version label and checkbox.
            if (bOneCan) {
                scope.xyz.bOneCanCreateVersion = true;
                scope.createVersionLabel = loginService.resourceStrings["CREATE_VERSION"]; // "Create Version";
            }
            else {
                scope.xyz.bOneCanCreateVersion = false;
                scope.xyz.createVersion = false;
                scope.createVersionLabel = loginService.resourceStrings["CREATE_VERSION_NOT_APPLICABLE"]; // "Create Version N/A";
            }

            // Handle enabling OK.
            scope.xyz.bReadyForOK = bAllHaveTarget && bAllHaveRequiredComment;
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {

            // Always set all items to not selected.
            angular.forEach(scope.gridOptions.data, function (item) {
                item.isSelected = false;
            });

            // Get the selected items.
            var items = [];
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item) {
                item.isSelected = true;
                items.push(item.selectionItem);
            });

            // Build the SL with mode and order.
            var slx = { mode: 0, order: 0, list: items };

            // ============================
            // Select Item. Steps.
            // ===========================+
            // Add users to the combo.
            scope.qualifiedStepsArrayLoading();
            if (items.length < 1) {
                scope.qualifiedStepsArrayLoad();
            }
            else {
                SelectionCommand_WorkflowService.GetStepListForWorkflowCommand(slx, scope.mode).then(function (response) {
                    scope.qualifiedStepsArrayLoad(response.data);
                }, function () {
                    scope.qualifiedStepsArrayLoad();
                });
            }

            // Update valid assignees.
            scope.updateAssignToList(slx, items);

            // Do Enables.
            scope.doEnables();
        };

        // Update valid assignees.
        scope.updateAssignToList = function (slx, items) {
            // ============================
            // Select Item. Assign To.
            // ===========================+
            // Add users to the combo.
            scope.qualifiedUsersArrayLoading();
            if (items.length < 1) {
                scope.qualifiedUsersArrayLoad();
            }
            else {
                SelectionCommand_WorkflowService.GetUserListForAssignWithLandingStep(slx, scope.mode).then(function (response) {
                    scope.qualifiedUsersArrayLoad(response.data);
                }, function () {
                    scope.qualifiedUsersArrayLoad();
                });
            }
        }

        // On click of the Expedite Approve button.
        scope.onExpediteApproveButtonClicked = function (slx) {

            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_EXPEDITOR_APPROVE;
            scope.xyz = { bReadyForOK: false, selectedWorkflowStepItem: {}, comment: "", selectedUserItem: {}, bOneCanCreateVersion: false, bCreateVersion: false };

            // dialog config
            scope.heading = loginService.resourceStrings["EXPEDITE_APPROVE"]; // "Expedite Approve";
            scope.selectWorkflowStepLabel = loginService.resourceStrings["SELECT_WORKFLOW_STEP"]; // "Select Workflow Step";
            scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT"]; // "Enter Comment";
            scope.assignToLabel = loginService.resourceStrings["ASSIGN_TO"]; // "Assign To";
            scope.createVersionLabel = loginService.resourceStrings["CREATE_VERSION"]; // "Create Version";
            scope.filesLabel = loginService.resourceStrings["FILES_TO_EXPEDITE_APPROVE"]; // "Files to Expedite Approve";
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // Get options and add to grid.
            scope.gridOptions.data = [];
            SelectionCommand_WorkflowService.GetApproveOptionsList(slx, scope.mode).then(function (response) {
                // It is OK to keep this seperate because the response item is different than the selection item.
                var bCommentRequired = [];
                var bWillCreateVersion = [];
                var bCanCreateVersion = [];
                angular.forEach(response.data, function (item, key) {
                    var fileId = key;
                    bCommentRequired[fileId] = item.bCommentRequired;
                    bWillCreateVersion[fileId] = item.bWillCreateVersion;
                    bCanCreateVersion[fileId] = item.bCanCreateVersion;
                });

                // For each selection item, add a row to the grid.
                var index = 0;
                angular.forEach(scope.slx.list, function (item) {
                    scope.gridOptions.data.push({
                        index: index,
                        selectionItem: item,
                        isSelected: true,
                        name: item.filename, library: item.detailedInfo.libName,
                        activeWorkflowName: item.detailedInfo.activeWorkflowName, activeStepName: item.detailedInfo.activeStepName,
                        workflowStep: "", workflowStepId: "",
                        bCommentRequired: bCommentRequired[item.fileId] ? 'T' : 'F', comment: "",
                        assignToId: "", assignTo: "",
                        bWillCreateVersion: bWillCreateVersion[item.fileId] ? 'T' : 'F',
                        bCanCreateVersion: bCanCreateVersion[item.fileId] ? 'T' : 'F', bCreateVersion: 'F'
                    });
                    index++;
                });

                $timeout(function () {
                    refreshGrid();
                    scope.gridApi.selection.selectAllRows();
                    $timeout(function () {
                        refreshGrid();
                    }, 2000);
                }, 500);

            });
        };

        // On click of the Expedite Reject button.
        scope.onExpediteRejectButtonClicked = function (slx) {

            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_EXPEDITOR_REJECT;
            scope.xyz = { bReadyForOK: false, selectedWorkflowStepItem: {}, comment: "", selectedUserItem: {}, bOneCanCreateVersion: false, bCreateVersion: false };

            // dialog config
            scope.heading = loginService.resourceStrings["EXPEDITE_REJECT"]; // "Expedite Reject";
            scope.selectWorkflowStepLabel = loginService.resourceStrings["SELECT_WORKFLOW_STEP"]; // "Select Workflow Step";
            scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT"]; // "Enter Comment";
            scope.assignToLabel = loginService.resourceStrings["ASSIGN_TO"]; // "Assign To";
            scope.createVersionLabel = loginService.resourceStrings["CREATE_VERSION"]; // "Create Version";
            scope.filesLabel = loginService.resourceStrings["FILES_TO_EXPEDITE_REJECT"]; // "Files to Expedite Reject";
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // Get options and add to grid.
            scope.gridOptions.data = [];
            SelectionCommand_WorkflowService.GetApproveOptionsList(slx, scope.mode).then(function (response) {
                // It is OK to keep this seperate because the response item is different than the selection item.
                var bCommentRequired = [];
                var bWillCreateVersion = [];
                var bCanCreateVersion = [];
                angular.forEach(response.data, function (item, key) {
                    var fileId = key;
                    bCommentRequired[fileId] = item.bCommentRequired;
                    bWillCreateVersion[fileId] = item.bWillCreateVersion;
                    bCanCreateVersion[fileId] = item.bCanCreateVersion;
                });

                // For each selection item, add a row to the grid.
                var index = 0;
                angular.forEach(scope.slx.list, function (item) {
                    scope.gridOptions.data.push({
                        index: index,
                        selectionItem: item,
                        isSelected: true,
                        name: item.filename, library: item.detailedInfo.libName,
                        activeWorkflowName: item.detailedInfo.activeWorkflowName, activeStepName: item.detailedInfo.activeStepName,
                        workflowStep: "", workflowStepId: "",
                        bCommentRequired: bCommentRequired[item.fileId] ? 'T' : 'F', comment: "",
                        assignToId: "", assignTo: "",
                        bWillCreateVersion: bWillCreateVersion[item.fileId] ? 'T' : 'F',
                        bCanCreateVersion: bCanCreateVersion[item.fileId] ? 'T' : 'F', bCreateVersion: 'F'
                    });
                    index++;
                });

                $timeout(function () {
                    refreshGrid();
                    scope.gridApi.selection.selectAllRows();
                    $timeout(function () {
                        refreshGrid();
                    }, 2000);
                }, 500);

            });
        };

        // On click of the RejectTo button.
        scope.onRejectToButtonClicked = function (slx) {

            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_REJECT_TO;
            scope.xyz = { bReadyForOK: false, selectedWorkflowStepItem: {}, comment: "", selectedUserItem: {}, bOneCanCreateVersion: false, bCreateVersion: false };

            // dialog config
            scope.heading = loginService.resourceStrings["REJECT_TO"]; // "Reject To";
            scope.selectWorkflowStepLabel = loginService.resourceStrings["SELECT_WORKFLOW_STEP"]; // "Select Workflow Step";
            scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT"]; // "Enter Comment";
            scope.assignToLabel = loginService.resourceStrings["ASSIGN_TO"]; // "Assign To";
            scope.createVersionLabel = loginService.resourceStrings["CREATE_VERSION"]; // "Create Version";
            scope.filesLabel = loginService.resourceStrings["FILES_TO_REJECT_TO"]; // "Files to Reject To";
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // Get options and add to grid.
            scope.gridOptions.data = [];
            SelectionCommand_WorkflowService.GetApproveOptionsList(slx, scope.mode).then(function (response) {
                // It is OK to keep this seperate because the response item is different than the selection item.
                var bCommentRequired = [];
                var bWillCreateVersion = [];
                var bCanCreateVersion = [];
                angular.forEach(response.data, function (item, key) {
                    var fileId = key;
                    bCommentRequired[fileId] = item.bCommentRequired;
                    bWillCreateVersion[fileId] = item.bWillCreateVersion;
                    bCanCreateVersion[fileId] = item.bCanCreateVersion;
                });

                // For each selection item, add a row to the grid.
                var index = 0;
                angular.forEach(scope.slx.list, function (item) {
                    scope.gridOptions.data.push({
                        index: index,
                        selectionItem: item,
                        isSelected: true,
                        name: item.filename, library: item.detailedInfo.libName,
                        activeWorkflowName: item.detailedInfo.activeWorkflowName, activeStepName: item.detailedInfo.activeStepName,
                        workflowStep: "", workflowStepId: "",
                        bCommentRequired: bCommentRequired[item.fileId] ? 'T' : 'F', comment: "",
                        assignToId: "", assignTo: "",
                        bWillCreateVersion: bWillCreateVersion[item.fileId] ? 'T' : 'F',
                        bCanCreateVersion: bCanCreateVersion[item.fileId] ? 'T' : 'F', bCreateVersion: 'F'
                    });
                    index++;
                });

                $timeout(function () {
                    refreshGrid();
                    scope.gridApi.selection.selectAllRows();
                    $timeout(function () {
                        refreshGrid();
                    }, 2000);
                }, 500);
            });
        };

        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            var colActiveWorkflow = loginService.resourceStrings["SCHEMA_S_WFNAME"];
            var colActiveStep = loginService.resourceStrings["SCHEMA_S_STEPNAME"];
            var colWorkflowStep = loginService.resourceStrings["WORKFLOW_STEP"];
            var colComment = loginService.resourceStrings["COMMENT"];
            var colAssignTo = loginService.resourceStrings["ASSIGN_TO"];
            var colCreateVersion = loginService.resourceStrings["CREATE_VERSION"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
            scope.gridOptions.columnDefs[2].name = colActiveWorkflow;
            scope.gridOptions.columnDefs[3].name = colActiveStep;
            scope.gridOptions.columnDefs[4].name = colWorkflowStep;
            scope.gridOptions.columnDefs[5].name = colComment;
            scope.gridOptions.columnDefs[6].name = colAssignTo;
            scope.gridOptions.columnDefs[7].name = colCreateVersion;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.onExpediteApproveDialogOK = function () {
            approvalAuthService.handleApprovalAuth(scope.slx).then(function(resp) {  
                if (resp == 'cancel') {
                    return;
                }
                scope.xyz.processing = true;

                if (scope.mode == scope.ACN_EXPEDITOR_APPROVE) {
                
                    // Check Required Fields
                    commandService.handleRequiredFields(scope.slx, 128).then(function (slx) {
    
                        if (slx.list.length == 0) {
                            $mdDialog.hide();
                            scope.xyz.processing = false;
                            return;
                        }
    
    
                        // Execute.
                        SelectionCommand_WorkflowService.ExpediteApprove(scope.slx).then(function (response) {
                            // Handle errors.
                            var atLeastOneError = false;
                            var selectionCommandResults = response.data;
                            var slx = selectionCommandResults.slx;
    
                            commandService.updateRequiredFields(slx.list).then(function () {
                                angular.forEach(slx.list, function (item) {
                                    if (atLeastOneError == false) {
                                        if (item.ec != 0) {
                                            atLeastOneError = true;
                                            if (atLeastOneError) {
                                                commandService.launchErrors({ slx: slx });
                                                //$rootScope.$broadcast('showErrorList', { slx: response.data });
                                            }
                                        }
                                    }
                                });
    
                                $timeout(function () {
                                    gridDataService.updateGridRecords(slx.list);
                                    //gridDataService.reloadGrid(); // $rootScope.$broadcast('grid:reload');
    
                                    editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                                    // Close dialog and refresh grid.
                                    $mdDialog.hide();
                                    scope.xyz.processing = false;
                                }, 300);
                            });
                        });
                    });
                    
                }
                else if (scope.mode == scope.ACN_EXPEDITOR_REJECT) {
                    // Execute.
                    SelectionCommand_WorkflowService.ExpediteReject(scope.slx).then(function (response) {
                        // Handle errors.
                        var atLeastOneError = false;
                        var selectionCommandResults = response.data;
                        var slx = selectionCommandResults.slx;
                        angular.forEach(slx.list, function (item) {
                            if (atLeastOneError == false) {
                                if (item.ec != 0) {
                                    atLeastOneError = true;
                                    if (atLeastOneError) {
                                        commandService.launchErrors({ slx: slx });
                                    }
                                }
                            }
                        });
                        // Close dialog and refresh grid.
                        $mdDialog.hide();
                        scope.xyz.processing = false;
                        gridDataService.updateGridRecords(slx.list);
    
                        editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                    });
                }
                else { // ACN_REJECT_TO
                    // Execute.
                    SelectionCommand_WorkflowService.RejectTo(scope.slx).then(function (response) {
                        // Handle errors.
                        var atLeastOneError = false;
                        var selectionCommandResults = response.data;
                        var slx = selectionCommandResults.slx;
                        angular.forEach(slx.list, function (item) {
                            if (atLeastOneError == false) {
                                if (item.ec != 0) {
                                    atLeastOneError = true;
                                    if (atLeastOneError) {
                                        commandService.launchErrors({ slx: slx });
                                    }
                                }
                            }
                        });
                        // Close dialog and refresh grid.
                        $mdDialog.hide();
                        scope.xyz.processing = false;
                        gridDataService.updateGridRecords(slx.list);
    
                        editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                    });
                }
            });
        };

        scope.onExpediteApproveDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.expediateApproveDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            switch (command) {
                case "expediteapprove":
                    scope.onExpediteApproveButtonClicked(records);
                    break;
                case "expeditereject":
                    scope.onExpediteRejectButtonClicked(records);
                    break;
                case "rejectto":
                    scope.onRejectToButtonClicked(records);
            }
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '14%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '12%', minWidth: '100' },
                { name: 'Active Workflow', field: 'activeWorkflowName', width: '12%', minWidth: '100' },
                { name: 'Active Step Name', field: 'activeStepName', width: '12%', minWidth: '100' },
                { name: 'Workflow Step', field: 'workflowStep', width: '12%', minWidth: '100' },
                { name: 'Comment', field: 'comment', width: '12%', minWidth: '100' },
                { name: 'Assign To', field: 'assignTo', width: '12%', minWidth: '100' },
                { name: 'Create Version', field: 'bCreateVersion', width: '12%', minWidth: '100' }, ],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
